import React from "react";
import { Box } from "@mui/material";
import TooltipInfoIcon from "@/components/TooltipInfoIcon";

interface InfoIconProps {
  tooltipText: string;
}

export const InfoIcon: React.FC<InfoIconProps> = ({ tooltipText }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      marginLeft: "4px",
      position: "relative",
      zIndex: 2,
    }}
  >
    <TooltipInfoIcon tooltipText={tooltipText} />
  </Box>
);
